<template>
  <div class="affiliate-navigation-bar-mobile">
    <div class="affiliate-navigation-bar-mobile__top">
      <div class="affiliate-navigation-bar-mobile__logos-wrapper">
        <img
          alt="abaca logo"
          class="affiliate-navigation-bar-mobile__abaca-logo"
          src="/img/logos/abaca-logo--white.svg"
        />
        <div v-if="logo" class="affiliate-navigation-bar-mobile__affiliate-logo-wrapper">
          <img
            :src="logo"
            alt="Affiliate Logo"
            class="affiliate-navigation-bar-mobile__affiliate-logo"
            @click="onLogoClick"
          />
        </div>
      </div>
    </div>
    <div v-if="showSteps && steps.length" class="affiliate-navigation-bar-mobile__bottom">
      <div
        v-for="(step, index) in steps"
        :key="`affiliate-navigation-bar-mobile:${index}`"
        :class="{
          'affiliate-navigation-bar-mobile__tab--active': step.id === activeStep,
          'affiliate-navigation-bar-mobile__tab--completed': step.id < activeStep,
          'affiliate-navigation-bar-mobile__tab--disabled': disabled,
        }"
        class="affiliate-navigation-bar-mobile__tab"
        @click="onStepClick(step.id)"
      >
        <div class="affiliate-navigation-bar-mobile__tab-circle">
          <PxIcon
            v-if="step.id < activeStep"
            name="check--white"
            :size="12"
          />
          <span v-else>{{ index + 1 }}</span>
        </div>
        <span class="affiliate-navigation-bar-mobile__tab-title">
          {{ $t(step.title) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { IAffiliateProgramNavBarStep } from "@/modules/affiliates/views/affiliate-types/affiliate-question-bundle.view.vue";

export default defineComponent({
  name: "AffiliateNavigationBarMobile",

  props: {
    logo: {
      type: String as PropType<string | null>,
      default: null,
    },

    externalLink: {
      type: String as PropType<string | null>,
      default: null,
    },

    steps: {
      type: Array as PropType<Array<IAffiliateProgramNavBarStep>>,
      default: () => [],
    },

    activeStep: {
      type: Number,
      default: 1,
    },

    showSteps: {
      type: Boolean,
      default: true,
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["update:activeStep", "reset-steps"],

  methods: {
    onStepClick(stepId: number) {
      if (this.disabled) return;
      this.$emit("update:activeStep", stepId);
      this.$emit("reset-steps");
    },

    onLogoClick() {
      if (this.externalLink) {
        window.open(this.externalLink, "_blank");
      }
    },
  },
});
</script>

<style lang="scss" scoped>
.affiliate-navigation-bar-mobile {
  @include gradient("blue-gradient-1", 273deg);
  width: 100%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  &__top {
    display: flex;
    justify-content: center;
    padding: 12px 20px;
  }

  &__logos-wrapper {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  &__abaca-logo {
    height: 28px;
  }

  &__affiliate-logo-wrapper {
    position: relative;
    padding-left: 12px;

    &::before {
      // position: absolute;
      // top: 50%;
      // left: 0;
      // width: 1px;
      // height: 16px;
      // content: "";
      // background-color: rgba($white, 0.2);
      // transform: translateY(-50%);
    }
  }

  &__affiliate-logo {
    max-height: 46px;
    max-width: 120px;
    cursor: pointer;
  }

  &__bottom {
    display: flex;
    justify-content: space-around;
    padding: 10px 0;
  }

  &__tab {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    flex: 1;
    cursor: pointer;
    opacity: 0.6;
    transition: opacity 0.3s;

    &--active {
      opacity: 1;

      .affiliate-navigation-bar-mobile__tab-circle {
        background-color: $white;
        color: $nice-blue;

        &::after {
          position: absolute;
          top: -3px;
          right: -3px;
          bottom: -3px;
          left: -3px;
          content: "";
          border: $white 1px solid;
          border-radius: 50%;
        }
      }

      .affiliate-navigation-bar-mobile__tab-title {
        @include grotesk(bold);
      }
    }

    &--completed {
      opacity: 1;

      .affiliate-navigation-bar-mobile__tab-circle {
        background-color: rgba($white, 0.4);
      }
    }

    &--disabled {
      pointer-events: none;
    }
  }

  &__tab-circle {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: rgba($white, 0.2);
    color: $white;
    font-size: 13px;
    @include grotesk(bold);
    transition: all 0.3s;
  }

  &__tab-title {
    color: $white;
    font-size: 13px;
    @include grotesk(medium);
    text-align: center;
    white-space: nowrap;
    transition: font-weight 0.3s;
  }
}
</style>
